import axios from "axios";
import { PagedResult } from "../models/paged-result";

export const CONVENIO_URL = `Convenio`;

export const convenioServices = {
  getList: (queryParams: any) => {
    return axios.get<PagedResult>(`${CONVENIO_URL}`, { params: queryParams });
  },
  getById: (id: string) => {
    return axios.get<any>(`${CONVENIO_URL}/${id}`);
  },
  getPracticasByOs: (
    obraSocialId: string,
    fecha: any,
    profesionalId: string,
    codigoPractica?: string
  ) => {
    let params = `id=${obraSocialId}&fecha=${fecha}&profesionalId=${profesionalId}`;
    if (codigoPractica) params = params + `&codigoPractica=${codigoPractica}`;
    return axios.get<any>(
      `${CONVENIO_URL}/GetPracticasByObraSocialIdAndDate?${params}`
    );
  },
  getPracticasList: (convenioId: string, queryParams: any) => {
    return axios.get<PagedResult>(`${CONVENIO_URL}/practicas-convenio-list/${convenioId}`, { params: queryParams });
  },
};
